import httpClient from './httpClient';
import { getTenantConfig } from '../../config/tenantConfig';

const getBaseUrl = () => {
  const config = getTenantConfig();
  return config.api.witnessStatement;
};

export const reviewerStatementService = {
  /**
   * List statements pending review
   * @returns {Promise<Object>} Response with statements array
   */
  async listStatementsForReview() {
    const response = await httpClient.get(`${getBaseUrl()}/statements/under-review`);
    return response; // httpClient already unwraps response.data
  },

  /**
   * Update reviewer fields in a statement
   * @param {string} statementId - Statement ID
   * @param {Object} updates - Updates object
   * @param {string} updates.reviewer_notes - Reviewer notes (optional)
   * @param {Array} updates.assertions - Assertion updates with ADVOKATE errors (optional)
   * @returns {Promise<Object>} Updated statement
   */
  async reviewStatement(statementId, updates) {
    const response = await httpClient.put(
      `${getBaseUrl()}/statements/${statementId}/review`,
      updates
    );
    return response; // httpClient already unwraps response.data
  },

  /**
   * Finalize a statement (generate PDF, mark as finalized)
   * @param {string} statementId - Statement ID
   * @returns {Promise<Object>} Finalized statement
   */
  async finalizeStatement(statementId) {
    const response = await httpClient.post(
      `${getBaseUrl()}/statements/${statementId}/finalize`
    );
    return response; // httpClient already unwraps response.data
  },

  /**
   * Reject a statement
   * @param {string} statementId - Statement ID
   * @param {Object} data - Rejection data
   * @param {string} data.reason - Rejection reason (required)
   * @returns {Promise<Object>} Rejected statement
   */
  async rejectStatement(statementId, data) {
    const response = await httpClient.post(
      `${getBaseUrl()}/statements/${statementId}/reject`,
      data
    );
    return response; // httpClient already unwraps response.data
  }
};

export default reviewerStatementService;
